module.exports = __webpack_public_path__ + "img/type_32-b-150_4_.prt.df8abbda.jpg";